import React, { useState } from 'react';

const CartaoCredito: React.FC = () => {
    const [divida, setDivida] = useState('');
    const [taxa, setTaxa] = useState('');
    const [pagamento, setPagamento] = useState('');

    const calcularCartao = () => {
        if (!divida || !taxa || !pagamento) return null;

        const D = parseFloat(divida);
        const i = parseFloat(taxa) / 100 / 30; // Taxa diária
        const P = parseFloat(pagamento);

        let meses = 0;
        let dividaAtual = D;
        let totalJuros = 0;

        while (dividaAtual > 0 && meses < 120) { // Máximo 10 anos
            const jurosMes = dividaAtual * i * 30;
            dividaAtual = dividaAtual + jurosMes - P;
            totalJuros += jurosMes;
            meses++;
        }

        return {
            meses: meses,
            totalJuros: totalJuros.toFixed(2),
            totalPago: (D + totalJuros).toFixed(2)
        };
    };

    const resultado = calcularCartao();

    return (
        <div>
            <h3 className="text-2xl font-bold text-gray-900 mb-6">Calculadora de Cartão de Crédito</h3>

            <div className="grid md:grid-cols-2 gap-8">
                <div className="space-y-4">
                    <div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                Dívida atual (R$)
                                <input
                                    type="number"
                                    value={divida}
                                    onChange={(e) => setDivida(e.target.value)}
                                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 mt-1"
                                    placeholder="1000"
                                />
                            </label>
                        </div>
                    </div>

                    <div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                Taxa de juros mensal (%)
                                <input
                                    type="number"
                                    value={taxa}
                                    onChange={(e) => setTaxa(e.target.value)}
                                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 mt-1"
                                    placeholder="15"
                                    step="0.1"
                                />
                            </label>
                        </div>
                    </div>

                    <div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                Pagamento mensal (R$)
                                <input
                                    type="number"
                                    value={pagamento}
                                    onChange={(e) => setPagamento(e.target.value)}
                                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 mt-1"
                                    placeholder="100"
                                />
                            </label>
                        </div>
                    </div>
                </div>

                <div>
                    {resultado && (
                        <div className="bg-indigo-50 border border-indigo-200 rounded-lg p-6">
                            <h4 className="text-lg font-semibold text-indigo-900 mb-4">Resultado:</h4>
                            <div className="space-y-3">
                                <div className="flex justify-between">
                                    <span className="text-indigo-700">Tempo para pagar:</span>
                                    <span className="font-bold text-indigo-900">{resultado.meses} meses</span>
                                </div>
                                <div className="flex justify-between">
                                    <span className="text-indigo-700">Total de juros:</span>
                                    <span className="font-bold text-indigo-900">R$ {resultado.totalJuros}</span>
                                </div>
                                <div className="flex justify-between text-lg">
                                    <span className="text-indigo-700">Total a pagar:</span>
                                    <span className="font-bold text-indigo-900">R$ {resultado.totalPago}</span>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default CartaoCredito;
